import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { selectTrialPeriod } from 'app/store/selector';
import { openSelectTrialFlowPopup as openSelectTrialFlowPopupAction } from 'app/store/trial-period.slice';

import createStyles from '@guestyci/foundation/createStyles';
import TextField from '@guestyci/foundation/TextField';
import { Section, Row } from '@guestyci/foundation/Layout';
import RaisedButton from '@guestyci/foundation/RaisedButton';
import iconSource from 'assets/icons/alarm-trial-end.svg';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';

import track from 'utils/dio/trial-locked-flow';
import getUserData from 'utils/user';

const useClasses = createStyles((theme: typeof defaultTheme) => ({
  root: {
    backgroundColor: theme.palette.secondary.default,
    '& > div:first-child': {
      width: '42.5rem', // 680px
    },
  },
}));

function TrialPeriodFooterBanner() {
  const { root } = useClasses();
  const state = useSelector(selectTrialPeriod);
  const [, gfhTrialTimerBar] = useFeatureToggle('gfhTrialTimerBar');
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { subscribed } = getUserData() || {};

  const isHidden = !state.showFooterBanner || subscribed;

  const handleClick = useCallback(() => {
    dispatch(openSelectTrialFlowPopupAction());

    track.subscribeBannerClickSubscribe(pathname);
  }, [dispatch, pathname]);

  useEffect(() => {
    if (!isHidden && gfhTrialTimerBar) {
      track.subscribeBannerView();
    }
  }, [gfhTrialTimerBar, isHidden]);

  if (isHidden || !gfhTrialTimerBar) {
    return null;
  }

  return (
    <Section className={root} gutter={4} justify="center">
      <Row justify="between" spacing={2} align="center">
        <Row spacing={2} align="center">
          <div>
            <img src={iconSource} alt="" />
          </div>
          <div>
            <TextField variant="h3" color="white">
              <span className="pr-1">{state.daysLeft}</span>
              days left in your free trial!
            </TextField>
            <TextField color="white">
              Subscribe to keep the tools that make hosting easier.
            </TextField>
          </div>
        </Row>
        <div>
          <RaisedButton onClick={handleClick}>Subscribe</RaisedButton>
        </div>
      </Row>
    </Section>
  );
}

export default TrialPeriodFooterBanner;
